<template>
  <b-container>
    <b-row class="mb-4 column-change">
      <b-col
        xl="8"
        lg="7"
        sm="12"
      >
        <InfoCard
          :transaction-date="dataIntegration.transaction_date || dataIntegration.created_at"
          :transaction-value="dataIntegration.value"
          :customer-name="customer ? customer.name : dataIntegration.customer_name"
          :customer-email="customer ? customer.email : dataIntegration.bar_code"
          :second-title="customer ? 'Email' : 'Código de Barras'"
          :customer-taxid="customer ? customer.tax_id : ''"
          :status-id="dataIntegration.status_id"
          :card="cardBrand"
        />

        <ProgressBarTransaction
          v-if="showProgressBar"
          :status-id="dataIntegration.status_id"
        />

        <TimeLineTransaction
          v-else
          :status-id="dataIntegration.status_id"
        />

        <RecurrenceTable
          v-if="dataIntegration.gsurf_recurrence_info"
          :table-data="dataIntegration.gsurf_recurrence_info.gsurf_recurrence_payments"
        />
      </b-col>

      <b-col
        md="12"
        class="mb-1"
        lg="5"
        xl="4"
      >

        <reciep>
          <b-row
            v-for="item of dataReciep"
            :key="item.key"
          >
            <b-col cols="6">
              <h5 class="reciep-text">
                {{ item.key }}:
              </h5>
            </b-col>

            <b-col
              cols="6"
              md="6"
            >
              <p class="prouct-name-capitalize reciep-text text-left">
                {{ item.value }}
              </p>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="6">
              <h5 class="reciep-text">
                Transacao
              </h5>
            </b-col>

            <b-col
              cols="6"
              md="6"
            >
              <p class="prouct-name-capitalize reciep-text text-left">
                {{ dataIntegration.transaction_date || dataIntegration.created_at | date }}
              </p>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="6">
              <h5 class="reciep-text">
                Valor:
              </h5>
            </b-col>

            <b-col
              cols="6"
              md="6"
            >
              <p class="prouct-name-capitalize reciep-text text-left">
                {{ dataIntegration.value | value }}
              </p>
            </b-col>

          </b-row>

        </reciep>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BCard, BContainer, BRow, BCol,
} from 'bootstrap-vue'
import InfoCard from '../components/InfoCard.vue'
import ProgressBarTransaction from '../components/ProgressBarTransaction.vue'
import TimeLineTransaction from '../components/TimeLine.vue'
import Reciep from '../components/Reciep.vue'
import RecurrenceTable from '../components/RecurrenceTable.vue'

const { statusObjectProgressBar } = require('@/information/detailsTransaction')

export default {
  components: {
    BContainer,
    InfoCard,
    BRow,
    BCol,
    ProgressBarTransaction,
    TimeLineTransaction,
    Reciep,
    RecurrenceTable,
  },

  data() {
    return {
      dataIntegration: (this.$store.getters['integration/order'] || this.$router.push('/integracao')),
      showProgressBar: true,
      customer: this.$store.getters['integration/order'].customer,
    }
  },

  computed: {
    dataReciep() {
      const { dataIntegration } = this
      const t = statusObjectProgressBar[dataIntegration.status_id]
      const arr = [
        { key: 'Nome', value: dataIntegration.customer?.name || dataIntegration.customer_name },
        { key: 'Documento', value: dataIntegration.customer?.tax_id },
        { key: 'Parcelas', value: dataIntegration.installments },
        { key: 'NSU', value: dataIntegration.nsu },
        { key: 'Autorizacao', value: dataIntegration.authorization_code },
      ]
      return arr.filter(item => !!item.value)
    },

    cardBrand() {
      return this.dataIntegration.creditCard?.brand.brand || ''
    }
  },

  created() {
    window.addEventListener('resize', this.handleCheckScreenSize)
  },

  methods: {
    handleCheckScreenSize() {
      if (window.innerWidth > 1200) {
        this.showProgressBar = true
      } else {
        this.showProgressBar = false
      }
    },
  },
}
</script>

<style>

</style>
